import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { GlobalStyle } from '../../theme/globalStyle';
import { mainTheme } from '../../theme/mainTheme';
import Footer from './Footer';
import NavBar from './NavBar';


const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Content = styled.main`
  flex: 1;
  z-index: 1;
  margin-top: ${({ theme }) => theme.navbarHeight.mobile};
  @media (min-width: ${({ theme }) => theme.screenSizeWidth.medium}) {
    margin-top: ${({ theme }) => theme.navbarHeight.desktop};
  }
`;

interface LayoutProps {
  children: React.ReactNode,
  withoutOrderFooter?: boolean,
}

const Layout = ({ children, withoutOrderFooter }: LayoutProps) => (
  <ThemeProvider theme={mainTheme}>
    <GlobalStyle />
    <Container>
      <NavBar />
      <Content>
        {children}
      </Content>
      <Footer withoutOrderFooter={withoutOrderFooter} />
    </Container>
  </ThemeProvider>
);


export default Layout;
